import { LinkListSlice } from '../../prismicio-types'
import styles from './LinkList.module.css'

export class LinkList {
	static render(props: LinkListSlice) {
		const { items } = props

		return /* HTML */ `
			<div class="${styles.Main}">
				${items
					.filter((item) => !!item.link)
					.map(({ link }) => {
						const uid = 'uid' in link ? link.uid : undefined
						return /* HTML */ `<a class="${styles.Item}" href="#${uid}">
							<span>${uid?.replace('-', ' ')}</span>
							<svg viewBox="0 0 26 27" xmlns="http://www.w3.org/2000/svg">
								<path d="M13 4V25" />
								<path d="M1 13L13.0208 25.0208L25.0416 13" />
							</svg>
						</a>`
					})
					.join('')}
			</div>
		`
	}
}
